import React from "react";
import PricingArea from "../../components/Pricing/PricingArea";
import Layout from "../../layouts/Layout";
import BreadcrumbArea from "../../components/BreadcrumbArea/BreadcrumbArea";
import NewsLetterArea from "../../components/NewsLetter/NewsLetterArea";
import DocumentMeta from "react-document-meta";
import { Helmet } from "react-helmet";

function Pricing() {
  return (
    <>
      <Helmet>
        <title>Pricing – Innovatix Hub Australia</title>
        <meta
          name="description"
          content="Innovatix Hub delivers innovative graphic design solutions that elevate your brand. Discover how our expert team can bring your vision to life. Contact us today!"
        />
        <meta name="robots" content="index,follow" />
        <meta name="author" content="Innovatix Hub" />
        <meta property="og:title" content="Pricing – Innovatix Hub Australia" />
        <meta
          property="og:description"
          content="Innovatix Hub delivers innovative graphic design solutions that elevate your brand. Discover how our expert team can bring your vision to life. Contact us today!"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_AU" />
        <meta property="og:site_name" content="Innovatix Hub AU" />
        <meta property="og:url" content="https://innovatixhub.com.au/pricing" />
        <meta
          property="og:image"
          content="https://innovatixhub.com.au/img/logo1.png"
        />
        <link rel="canonical" href="https://innovatixhub.com.au/pricing" />
      </Helmet>
      <Layout header={1} footer={1} className="" mainClassName="">
        <BreadcrumbArea
          title={"Pricing"}
          subtitle={"Our pricing plan"}
          className={"breadcrumb-area-two pt-175"}
          showShape={false}
        />
        <PricingArea />
        <NewsLetterArea />
      </Layout>
    </>
  );
}

export default Pricing;
